import React from 'react'
import injectSheet from 'react-jss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { COLORS } from 'helpers/globals'
import tippy from 'tippy.js'

class ExpansionWarning extends React.Component {
  componentDidMount = _ =>
    tippy(`.${this.props.classes.icon}`, {
      duration: 0,
      theme: 'topbar',
      placement: 'top',
      distance: 5
    })

  render = _ =>
    <span
      title='Not included in total length calculation'
      className={this.props.classes.icon}
    >
      <FontAwesomeIcon icon='info-circle' />
    </span>
}

const style = {
  icon: {
    fontSize: '1.1em',
    cursor: 'pointer',
    marginLeft: '.5rem',
    color: COLORS.primary
  }
}

export default (injectSheet(style)(ExpansionWarning))




// WEBPACK FOOTER //
// ./src/components/DoorControllerDetails/ethernetExpansionWarning.js